module.exports = __webpack_public_path__ + "/content/skins/honda-acura/fonts/330017_1_0.ttf";